<p-tag *ngIf="value() as status" styleClass="wrap" [value]="placementOptions[status].name" [severity]="placementOptions[status].color">
</p-tag>
